var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"LLAddLabel",class:_vm.classes,attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"LLAddLabel__icon"},[_vm._t("icon",function(){return [_c('PlusRoundedSolidIcon',{staticClass:"LLAddLabel__icon-remove"})]})],2),_c('div',{staticClass:"LLAddLabel__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }